import type { FilterSectionOption } from './filter-sections';

export function toggleFilterValue(
  current: string[] | undefined,
  value: string,
  options: FilterSectionOption[],
): string[] | undefined {
  const isExclusive = (candidate: string) => options.some((option) => option.value === candidate && option.exclusive);
  const values = current ?? [];

  let next: string[];
  if (values.includes(value)) {
    next = values.filter((v) => v !== value);
  } else if (isExclusive(value)) {
    next = [value];
  } else {
    next = [...values.filter((v) => !isExclusive(v)), value];
  }

  return next.length ? next : undefined;
}
